import React from 'react';
import PropTypes from 'prop-types';

import { Confirmation } from 'screens/shared';

const MetersConfirmation = ({
  onConfirm,
  onCancel,
  resetText
}) => {
  const [title, text] = resetText;

  const data = {
    content: { title, text },
    callbacks: { onConfirm, onCancel }
  };

  return <Confirmation content={data.content} callbacks={data.callbacks} />;
};

MetersConfirmation.defaultProps = {
  resetText: []
};

MetersConfirmation.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  resetText: PropTypes.arrayOf(PropTypes.string)
};


export default MetersConfirmation;



// WEBPACK FOOTER //
// ./src/screens/shared/Meters/MetersGenStats/MetersConfirmation/MetersConfirmation.js